import { Component, OnInit, Input, Sanitizer } from '@angular/core';

@Component({
  selector: 'app-browser-frame',
  templateUrl: './app-browser-frame.component.html',
})
export class AppBrowserFrameComponent implements OnInit {
  @Input() options: any = {
    url: ''
  };
  constructor(
  ) { }

  ngOnInit() {}
  
}
